import React, { ReactElement } from "react";
import { FunctionComponent } from "react";
import Slider from "react-slick";
import { FormattedMessage } from "react-intl";
import { SearchResultDebugInfo, SearchResultEx, SearchResultItem } from "shared/src/types/articlesearch/SearchResult";
import { ZeroResultTypes } from "shared/src/types/ZeroResultType";
import { SearchResultArticle } from "../../shared/article-badges/SearchResultArticle";
import * as articleUtils from "../../../../utils/articleUtils";
import SearchResultLayout from "../../shared/article-badges/SearchResultLayout";
import * as bundleSelectionUtil from "../../../../utils/BundleSelectionUtil";
import SearchResultNoArticle from "../../shared/article-badges/SearchResultNoArticle";
import * as _ from "lodash";
import { sliderSettings } from "./ZeroResultSettings";
import { SearchResultRenderData } from "shared/src/types/RenderData";

type OrSearchSuggestionsProps = {
    results: SearchResultEx | undefined | null;
};

const OrSearchSuggestions: FunctionComponent<OrSearchSuggestionsProps> = ({
    results
}: OrSearchSuggestionsProps): ReactElement | null => {
    if (results && results.result && results.result.length > 0) {
        const items = _.slice(results.result, 0, 4);
        return (
            <div className="zero-result-article-suggestions zero-result-module">
                <h3>
                    <FormattedMessage id="SD_ZERO_RESULTS_OR_SEARCH" />
                </h3>
                <p>
                    <FormattedMessage id="EX_NO_RESULT_USED_OR_SEARCH" />
                </p>
                <Slider {...sliderSettings} className="mfcss_card-article-2--grid-container-flex">
                    {items.map((item: SearchResultItem, index: number) => {
                        return <div key={item.id}>{renderArticleCard(results?.query, item, index)}</div>;
                    })}
                </Slider>
            </div>
        );
    } else {
        return null;
    }
};

export function renderArticleCard(query: string, item: SearchResultItem, index: number) {
    if (item.state === "requested" || item.state === "loading") {
        return null;
    }

    const reactId = (item.type || "") + item.id + index;

    const renderData = renderDataFromVariant(item.variant, item.position, item.debugInfo, query);

    if (renderData && item.state !== "missing" && item.state !== "error") {
        return (
            <SearchResultArticle
                key={reactId}
                inContainer={false}
                item={renderData}
                onList={item.onList}
                recentlyOrdered={item.recentlyOrdered}
                searchResultLayout={SearchResultLayout.GRID}
                pageType={"ZERO_RESULT"}
                zeroResultType={ZeroResultTypes.OrSearch}
                deprecated={false}
                query={query}
                solrScore={item.solrScore}
                showOtherBundle={false}
            />
        );
    } else {
        return (
            <SearchResultNoArticle
                key={item.id}
                inContainer={false}
                item={item.id}
                searchResultLayout={SearchResultLayout.GRID}
                __bypassReactAdapter
            />
        );
    }
}

function renderDataFromVariant(
    variant:
        | {
              [x: string]: any;
          }
        | undefined
        | null,
    position: number | undefined | null,
    debugInfo: SearchResultDebugInfo | undefined | null,
    query: string
): SearchResultRenderData | null {
    if (!variant) {
        return null;
    }
    const selectedBundle = bundleSelectionUtil.chooseBundleToShow(variant.bundles, null, undefined, query);
    return {
        name: variant.description,
        url: variant.imageUrl,
        variant: variant,
        variantId: variant.variantId,
        bundles: articleUtils.bettyBundleIdInsteadOfBundleNumber(variant.bundles, variant.bundles),
        selectedBundle: selectedBundle,
        bundleSelector: { selectedBundle }, // provide only one bundle to not display the bundle selector
        position: position,
        type: "ZeroResultSuggestion",
        debugInfo: debugInfo,
        ltrDebugInfo: null,
        ropoRank: null
    };
}

export default OrSearchSuggestions;
